// Module
var code = "<select class=\"initFormSelect\" data-type=\"{{type}}\">\r\n\t{{#each values}}\r\n\t\t<option value=\"{{id}}\" {{#if selected}}selected{{/if}}>{{desc}}</option>\r\n\t{{/each}}\r\n</select>";
// Exports
export default code;